// extracted by mini-css-extract-plugin
export default {"image":"VY-z","loaded":"WY-z"};